import "../styles/css/request-estimate.css";
import {useLocation} from "react-router-dom";

const PaymentThanksPage: React.FC = () => {
    const location = useLocation();
    const state = location.state as {
        customerName?: string;
        paidJobs?: Array<{ jobId: number; amountCharged: number; transactionId: string }>;
    } | null;

    const customerName = state?.customerName || "valued customer";
    const paidJobs = state?.paidJobs || [];
    const totalPaid = paidJobs.reduce((sum, j) => sum + j.amountCharged, 0);

    return (
        <div className="request-body">
            <div className="container estimate-container">
                <div className="page-card estimate-thanks">
                    <i className="fas fa-thumbs-up thanks-icon"></i>
                    <h1>Thanks!</h1>
                    {paidJobs.length > 0 ? (
                        <>
                            <p>
                                Thank you, {customerName}. Your payment{paidJobs.length > 1 ? "s totaling" : " of"}{" "}
                                <strong>${totalPaid.toFixed(2)}</strong> {paidJobs.length > 1 ? "have" : "has"} been
                                processed successfully.
                            </p>
                            <p>A receipt will be emailed to you shortly.</p>
                        </>
                    ) : (
                        <p>Your payment has been processed. A receipt will be emailed to you shortly.</p>
                    )}
                    <p>
                        (847) 970-5900
                        <br/>
                        <a href="mailto:barrecablacktop@gmail.com">barrecablacktop@gmail.com</a>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default PaymentThanksPage;
